import React, { useState, useEffect } from 'react';

import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import DeleteIcon from '@material-ui/icons/Delete';

import UseStyles from '../../../useStyles';
import { useFileDrop } from "../../../../shared/uploadFile/dragDrop";
import DocumentIcons from "../../../../../images/icons/document-icon.svg";
import PautaIcon from "../../../../../images/icons/ata-icon.svg";
import DocBtn from "../../../../documento/botaoDownload";

import { useSnackbar } from 'notistack';

import {cadastrarAta, getAtaByIdReuniao, removerAta} from '../../../../../services/reuniao/ReuniaoService';

import { download } from '../../../../../services/documento/DocumentoService';

import moment from 'moment';

import { atualizar } from '../../../../../services/reuniao/ReuniaoService';


const ReuniaoAbaPauta = (props) => {

  const classes = UseStyles();

  const { enqueueSnackbar } = useSnackbar();

  const [state, setState] = useState(true);
  const [extra, setExtra] = useState(false);

  const initialState = {
    expediente: '',
    ordem: '',
    comunicacoes: '',
    outros: ''
  };

  const uploadFile = async (arquivo) => {
    const nomeArquivo = arquivo.name.split('.')[0];
    const formData = new FormData();
    formData.append('idReuniao', dados.id);
    formData.append('file', arquivo);
    formData.append('nome', nomeArquivo);

    try {
      const response = await cadastrarAta(formData);
      console.log(`Response ${response}`);
      updateDados({ ...dados, ata: { id: response.data, nome: nomeArquivo } });
      setState((prev) => !prev);
    } catch (e) {
      enqueueSnackbar('Ocorreu um erro ao cadastrar a ata', { variant: 'error' })
    }
  }

  const onChangeHandler = (event) => {
    if (event.target.files.length > 0) {
      uploadFile(event.target.files[0]);
    }
  }

  const removeAta = async () => {
    try {
      const response = await removerAta(dados.ata.id);
      console.log(`Response ${response}`);
      updateDados({ ...dados, ata: null });
      setState((prev) => !prev);
    } catch (e) {
      enqueueSnackbar('Ocorreu um erro ao remover a ata', { variant: 'error' })
    }
  }

  const downloadAta = async () => {
    if (dados.ata && dados.ata.id) {
      try {
        const response = await download(dados.ata.id);
        const url = URL.createObjectURL(new Blob([response.data]));
        const a = document.createElement('a');
        a.href = url;
        document.body.appendChild(a);
        a.download = `${dados.ata.nome}.${dados.ata.formato}`;
        a.click();
      } catch (e) {
        enqueueSnackbar('Ocorreu um erro ao realizar o download da ata', { variant: 'error' })
      }
    }
  }

  const {
    DropBox, HiddenInput, onClick, drag,
  } = useFileDrop(uploadFile);

  const { validar, handleStepper, dados, updateDados, isEdicao, history } = props;

  const checkDate = () => {
    const hoje = moment();
    const reuniaoData = moment(dados.data, "DD/MM/YYYY");
    return hoje.isBefore(reuniaoData);
  }

  const validarCampos = (skip = false) => {
    validar.validado = true;

    let data = moment(dados.data + ' ' + dados.hora, 'DD/MM/YYYY HH:mm');
    const reuniao = {
      id: dados.id,
      idConselho: dados.conselho,
      edicao: dados.edicao,
      periodicidade: dados.periodicidade,
      data: data.format('YYYY-MM-DDTHH:mm:ss'),
      descricao: dados.descricao,
      cep: dados.cep.replace('-', ''),
      estado: dados.estado.nome,
      cidade: dados.cidade,
      endereco: dados.endereco,
      pauta: dados.expediente,
      pautaExtra: dados.pautaExtra,
      ata: dados.ata !== '' ? dados.ata : null
    };

    atualizar(reuniao).then((response) => {
      if (response && response.status === 200) {
        if(!skip) {
          handleStepper(2);
        }else {
          history.push(`/reuniao/${dados.id}/visualizar`);
        }
      }
    });
  }

  useEffect(() => {
    validar.validado = true;
    getAta();
  }, []);

  const getAta = async () => {
    const response = await getAtaByIdReuniao(dados.id);
    updateDados({ ...dados, ata: response.data});
    setState((prev) => !prev);
  }

  return (
    <div className={classes.reunioesInputEditor}>
      <Grid style={{ marginTop: 24 }} container spacing={4}>
        <Grid item md={isEdicao ? 6 : 12} sm={isEdicao ? 6 : 12} xs={12}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography className={classes.tituloAba}>Pauta e Ata</Typography>
            {isEdicao && <Button onClick={() => setExtra(true)} variant="outlined">Incluir extra Pauta</Button>}
          </div>
          <Grid container spacing={4} style={{ marginTop: 24 }}>
            <Grid item md={12} sm={11} xs={11}>
              <CKEditor
                style={{ height: '200px' }}
                config={{
                  toolbar: ['heading', 'bold', 'italic', 'bulletedList', 'numberedList', 'blockQuote', 'link',],
                  heading: {
                    options: [
                      { model: 'paragraph', title: 'Normal', class: 'ck-heading_paragraph' },
                      { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
                      { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' }
                    ]
                  }
                }}
                data={dados.expediente}
                editor={ClassicEditor}
                onInit={() => { }}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  updateDados({ ...dados, expediente: data });
                  console.log(data);
                }}
              />
            </Grid>
            {(dados.pautaExtra || (isEdicao && extra)) && <Grid item md={12} sm={11} xs={11}>
              <Typography className={classes.reunioesTituloCampoEditor}>Extra Pauta</Typography>
              <CKEditor
                config={{
                  toolbar: ['heading', 'bold', 'italic', 'bulletedList', 'numberedList', 'blockQuote', 'link',],
                  heading: {
                    options: [
                      { model: 'paragraph', title: 'Normal', class: 'ck-heading_paragraph' },
                      { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
                      { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' }
                    ]
                  }
                }}
                data={dados.pautaExtra}
                editor={ClassicEditor}
                onInit={editor => { }}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  updateDados({ ...dados, pautaExtra: data });

                }}
              />
            </Grid>}
          </Grid>
        </Grid>
        {isEdicao && <Grid item md={6} sm={6} xs={12}>
          <div style={{ display: 'flex', width: '100%', justifyContent: 'flex-end', gap: 8 }}>
            <Button onClick={() => validarCampos(true)} variant='contained'>Finalizar</Button>
            <Button onClick={() => validarCampos()} variant='contained'>Próximo</Button>
          </div>
          {checkDate() ? <>
            <div style={{ borderRadius: 4, border: '1px solid #c2c4d1', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', padding: 24, marginTop: 40, cursor: 'not-allowed' }}>
              <img src={PautaIcon} />
              <Typography style={{ color: '#5e6784', fontSize: 16, width: '100%', maxWidth: 350, marginTop: 24, textAlign: 'center' }}>A ata estará disponível para preenchimento após a realização da reunião</Typography>
            </div>
          </> : <>
            {(dados.ata === null || dados.ata === '' ) &&
              <>
                <HiddenInput />
                <DropBox style={{ marginTop: 40 }} className={drag ? classes.campoOnDragAtivo : classes.campoOnDrag}>
                  <img src={DocumentIcons} />
                  <div style={{ marginTop: 30 }} id="formulario">
                    <label className={classes.mainButon} htmlFor="input-termo-posse" role="button">
                      Adicionar a ata
                      </label>
                    <input
                      style={{ display: 'none' }}
                      id="input-termo-posse"
                      type="file"
                      name="file"
                      onChange={onChangeHandler}
                    />
                  </div>
                  <p>ou arraste o arquivo aqui para adicionar</p>
                </DropBox>
              </>
            }
            {dados.ata &&
              <div style={{ marginTop: 80, position: 'relative' }}>
                <DocBtn large onClickHandle={downloadAta}>
                  <Typography>Download da ata</Typography>
                </DocBtn>
                <div style={{ position: 'absolute', top: 5, right: 5 }}>
                  <Button onClick={removeAta}>
                    <DeleteIcon />
                  </Button>
                </div>
              </div>}
          </>}
        </Grid>}
      </Grid>
      {!isEdicao && <div style={{ float: 'right', marginBottom: 10, marginTop: 24 }}>
        <Button onClick={() => validarCampos()} variant='contained'>Próximo</Button>
      </div>}
    </div>
  );
}

export default ReuniaoAbaPauta;
